module.exports = __webpack_public_path__ + "img/home-largest-certificate.c38d726b.png";